import AxiosInstance from 'src/shared/services/axios/interceptor';
import { FeeArticleRequest, FeeArticleSettings } from 'src/shared/models/invoiceGroup/feeArticle';

const controller = 'FeeArticle';

export const getFeeArticlesByOwnerId = (ownerId: number) => {
  return AxiosInstance.get<FeeArticleSettings>(`${controller}/${ownerId}`);
};

export const saveFeeArticle = (data: FeeArticleRequest) => {
  return AxiosInstance.put(controller, data);
};
